import React from 'react';
import { Formik, Form } from 'formik';

import { FormElement, Label } from '@dashboard/components/Form';
import { Textarea } from '@dashboard/components/Formik';

import FormSubmit from '@dashboard/components/Formik/components/FormSubmit';
import { transformApiErrorToFormik } from '@dashboard/services/form';
import { isEmpty } from 'lodash';
import FormError from '@dashboard/components/Formik/components/FormError';
import usePage from '@dashboard/hooks/usePage';
import { UnsavedChangesReporter } from '@dashboard/components/UnsavedChanges';

const ThirdPartyAnalyticsForm = () => {
  const { page, updatePage } = usePage();

  return (
    <Formik
      initialValues={{ trackingCodes: page.trackingCodes }}
      onSubmit={async (values, actions) => {
        actions.setStatus(undefined);

        const { data, error } = await updatePage.mutateAsync(values);

        if (data) {
          actions.setStatus('');
          actions.resetForm({
            values: {
              trackingCodes: data.trackingCodes,
            },
          });
        } else {
          const { status, errors } = transformApiErrorToFormik(error);

          if (!isEmpty(errors)) {
            actions.setErrors(errors);
          } else {
            actions.setStatus(status);
          }
        }
      }}
    >
      {({ status, dirty, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <UnsavedChangesReporter />
          <FormElement>
            <Label htmlFor="trackingCodes">Tracking codes</Label>
            <Textarea
              id="trackingCodes"
              name="trackingCodes"
              placeholder="Paste tracking codes"
              autosize
              minRows={6}
            />

            <FormError name="trackingCodes" />
          </FormElement>

          <FormElement>{status && status}</FormElement>

          <FormSubmit>
            <FormSubmit.Button>Save</FormSubmit.Button>
            <FormSubmit.State visible={!!dirty} />
          </FormSubmit>
        </Form>
      )}
    </Formik>
  );
};

export default ThirdPartyAnalyticsForm;
